import { render } from "./LocatorList.vue?vue&type=template&id=b9ef11e0&scoped=true&ts=true"
import script from "./LocatorList.vue?vue&type=script&lang=ts"
export * from "./LocatorList.vue?vue&type=script&lang=ts"

import "./LocatorList.vue?vue&type=style&index=0&id=b9ef11e0&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b9ef11e0"]])

export default __exports__